import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { SetDiagnosticFilterValuesHandler } from "./handler";
import { SetDiagnosticFiltersValuesCommand } from "./request";

let setFiltersValueRequest: BrokerDisposableHandler;

export const bootstrapSetDiagnosticFilter = (broker: BrokerExtensions) => {
  setFiltersValueRequest = broker.registerRequest(SetDiagnosticFiltersValuesCommand, SetDiagnosticFilterValuesHandler);
};

export const teardownSetDiagnosticFilter = () => {
  setFiltersValueRequest?.dispose();
};
